// web/src/components/enroll/ShieldBanner.tsx — the persistent "what the server can
// see" assurance shown across the enrollment & sealing surfaces (ADR-003; content
// guide §3). The copy is load-bearing and verbatim from the content guide — it
// states what the server CANNOT do as plainly as what it can. Token-only.
import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Icon } from '../ui/Icon';

export interface ShieldBannerProps {
  /** The lead sentence; defaults to the initiator framing. */
  lead?: React.ReactNode;
  /** The mono confidentiality note under the lead. */
  note?: string;
}

export function ShieldBanner({
  lead = 'You are the initiating party. The plaintext stays in your browser; it is split and encrypted here, then only ciphertext shards are delivered.',
  note = 'The server stores ciphertext and metadata only — never your secret.',
}: ShieldBannerProps): React.JSX.Element {
  return (
    <div className="bgShieldBanner" role="note">
      <span className="bgShieldIcon" aria-hidden="true">
        <Icon icon={ShieldCheck} size="md" />
      </span>
      <p>
        {lead}
        <span className="bgShieldNote">{note}</span>
      </p>
    </div>
  );
}

export default ShieldBanner;
